import api from "../api";
import errorHandler from "../utils/errorHandler";

const createSuccess = (competidor) => ({
  type: "CREATE_COMPETIDOR_SUCCESS",
  competidor,
});

const findSuccess = (dados) => ({
  type: "FIND_COMPETIDORES_SUCCESS",
  dados,
});

const findByIdSuccess = (competidor) => ({
  type: "FIND_BY_ID_COMPETIDOR_SUCCESS",
  competidor,
});

const findByIdAndUpdateSuccess = (competidor) => ({
  type: "UPDATE_COMPETIDOR_SUCCESS",
  competidor,
});

const addError = (errors) => ({
  type: "ADD_COMPETIDOR_ERROR",
  errors,
});

export const create = (dados) => async (dispatch) => {
  return api.competidor
    .create(dados)
    .then((data) => {
      return dispatch(createSuccess(data));
    })
    .catch((error) => {
      dispatch(addError(errorHandler.getError(error)));
    });
};

export const findById = (id) => async (dispatch) => {
  return api.competidor
    .findById(id)
    .then((data) => {
      return dispatch(findByIdSuccess(data));
    })
    .catch((error) => {
      dispatch(addError(errorHandler.getError(error)));
    });
};

export const find = () => async (dispatch) => {
  return api.competidor
    .find()
    .then((data) => {
      return dispatch(findSuccess(data));
    })
    .catch((error) => {
      dispatch(addError(errorHandler.getError(error)));
    });
};

export const findByCampeonato = (campeonatoId) => async (dispatch) => {
  return api.competidor
    .findByCampeonato(campeonatoId)
    .then((data) => {
      return dispatch(findSuccess(data));
    })
    .catch((error) => {
      dispatch(addError(errorHandler.getError(error)));
    });
};

export const findByIdAndUpdate = (id, data) => async (dispatch) => {
  return api.competidor
    .findByIdAndUpdate(id, data)
    .then((data) => {
      return dispatch(findByIdAndUpdateSuccess(data));
    })
    .catch((error) => {
      dispatch(addError(errorHandler.getError(error)));
    });
};
